import { GOAL_DIRECTORY_ARCHIVED_PAGE } from '@townsquare/config/routes';
import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import GoalDirectoryQuery, {
	GoalDirectoryQuery as GoalDirectoryQueryType,
} from '../components/__generated__/GoalDirectoryQuery.graphql';

export const goalDirectoryResource = createRelayResource<GoalDirectoryQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		return {
			query: GoalDirectoryQuery,
			variables: {
				aaid: context.user.accountId,
				workspaceId: context.workspace?.globalId ?? '',
				workspaceUuid: context.workspace?.UUID,
				containerId: context.collabContext?.contextId,
				newGoalFilterResolversEnabled: fg('townsquare_enable_new_directory_filters'),
				includeArchived: routerContext.route.name === GOAL_DIRECTORY_ARCHIVED_PAGE,
			},
		};
	},
});
